import React, { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EconsultActionButton, EconsultCancelButton } from '@oh-vcp/components-ui';
import { Stack } from '@mui/system';

interface EconsultDraftLostWarningDialogProps {
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
}

const EconsultDraftLostWarningDialog: FC<EconsultDraftLostWarningDialogProps> = ({
  isOpen,
  onLeave,
  onStay
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        <Typography variant="h2" color="base.grey4">
          {t('Case.draft.warningTitle')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: 400 }}>
        <Typography color="base.grey4" mb={1}>
          {t('Case.draft.warningText1')}
        </Typography>
        <Typography color="base.grey4" mb={3}>
          {t('Case.draft.warningText2')}
        </Typography>
        <Stack direction="row" justifyContent="end">
          <EconsultActionButton
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={onLeave}>
            {t('Case.draft.warningConfirm')}
          </EconsultActionButton>
          <EconsultCancelButton variant="contained" onClick={onStay}>
            {t('Case.draft.warningCancel')}
          </EconsultCancelButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultDraftLostWarningDialog;
